import styles from "./Header.module.css";
import { Link } from "react-scroll";

import { IoMdContact } from "react-icons/io";
import React from "react";

import {
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import {
  AddIcon,
  ExternalLinkIcon,
  HamburgerIcon,
  RepeatIcon,
} from "@chakra-ui/icons";
import Ravinder_Saini_Resume from "../assests/Ravinder_Saini_Resume.pdf";
import { FaHome } from "react-icons/fa";
import { HiOutlineDocumentDownload } from "react-icons/hi";

export const Header = () => {
  return (
    <div>
      <div className={styles.header}>
        <i className={styles.name}>Ravinder Saini</i>
        <Link className={styles.heading} to="home" smooth={true} duration={500}>
          Home
        </Link>
        <Link
          className={styles.heading}
          to="about"
          smooth={true}
          duration={500}
        >
          About
        </Link>
        <Link
          className={styles.heading}
          to="skills"
          smooth={true}
          duration={500}
        >
          Skills
        </Link>
        <Link
          className={styles.heading}
          to="projects"
          smooth={true}
          duration={500}
        >
          Projects
        </Link>

        <a className={styles.resume} href={Ravinder_Saini_Resume} download>
          Resume
        </a>
        <Link
          className={styles.lastheading}
          to="contact"
          smooth={true}
          duration={500}
        >
          Contact
        </Link>
      </div>

      <div className={styles.ThirdNav}>
        {/* <div><h1>AS</h1></div> */}
        <div className={styles.menu}>
          <Menu>
            <MenuButton
              as={IconButton}
              aria-label="Options"
              icon={<HamburgerIcon />}
              variant=""
              color="white"
            />
            <MenuList>
              <Link to="home" smooth={true} duration={500}>
                {" "}
                <MenuItem h="50px" icon={<FaHome size={15} />}>
                  Home
                </MenuItem>
              </Link>
              <Link to="about" smooth={true} duration={500}>
                <MenuItem h="50px" icon={<AddIcon />}>
                  About
                </MenuItem>
              </Link>
              <Link to="skills" smooth={true} duration={500}>
                {" "}
                <MenuItem h="50px" icon={<ExternalLinkIcon />}>
                  Skills
                </MenuItem>
              </Link>
              <Link to="projects" smooth={true} duration={500}>
                {" "}
                <MenuItem h="50px" icon={<RepeatIcon />}>
                  Project
                </MenuItem>
              </Link>
              <Link to="contact" smooth={true} duration={500}>
                <MenuItem h="50px" icon={<IoMdContact size={20} />}>
                  Contact
                </MenuItem>
              </Link>
              <a
                style={{ color: "teal" }}
                href={Ravinder_Saini_Resume}
                download
              >
                <MenuItem
                  h="50px"
                  icon={<HiOutlineDocumentDownload size={20} />}
                >
                  Resume
                </MenuItem>
              </a>
            </MenuList>
          </Menu>
        </div>
      </div>
    </div>
  );
};
